import { IModel } from "@/@types/models/model";
import coreFields from "./helpers/coreFields";

const DynamicFormsModelFields: IModel = {
  title: 'Dynamic Form Fields',
  apiPath: 'system/forms/{id}/fields',
  forms: {
    default: {
      fields: ['id', 'title', 'title_ttoken', 'source', "type", "is_required", "sortorder", 
        // "picker_options"
      ],
    },
  }, 
  listViews: {
    default: {
      fields: ['id', 'title', 'title_ttoken', 'source', "type", "is_required", "sortorder", 
        // "picker_options",
        // "edit",
      ],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'form_id',
      source: 'form_id',
      ttoken: 'admin:common.form_id',
      type: 'numeric',
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'title',
      source: 'title',
      ttoken: 'admin:common.title',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'title_ttoken',
      source: 'title_ttoken',
      ttoken: 'admin:common.title_ttoken',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'source',
      source: 'source',
      ttoken: 'admin:common.source',
      type: 'text',
      filter: true,
      validation: { required: true },
    },
    // {
    //   title: 'type',
    //   source: 'type',
    //   ttoken: 'admin:common.type',
    //   type: 'text',
    //   filter: true,
    //   validation: { required: true },
    // },
    {
      title: 'type', 
      source: 'type',
      ttoken: 'admin:common.type',
      type: 'picker', 
      subModel: {
        apiPath: 'system/form-field-types?view=picker',
        format: '{label}',
      },
      translate: true,
      validation: { required: false },
    },
    {
      title: 'is_required',
      source: 'is_required', 
      ttoken: 'admin:common.is_required', 
      type: 'boolean',
      filter: true,
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        default: false,
      },
      validation: { required: true },
    },
    {
      title: 'sortorder',
      source: 'sortorder',
      ttoken: 'admin:common.sortorder',
      type: 'numeric', 
      filter: true,
      validation: { required: true },
    },
    // {
    //   title: 'picker_options',
    //   source: 'picker_options',
    //   ttoken: 'admin:common.picker_options',
    //   type: 'picker',
    //   subModel: {
    //     apiPath: 'system/app_permissions?view=picker',
    //     format: '{label}',
    //     idattr: 'id',
    //   },
    //   translate: true,
    // },
    // buttonFields.edit,
  ],
}

export default DynamicFormsModelFields;
